/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Deha8 = props => (
  <svg viewBox="0 0 128 128" width="1em" height="1em" {...props}>
    <path d="M104.615 57.595c-1.308-3.755-4.736-17.799-4.736-17.799S97.266 15.3 89.101 7.789C80.936.277 64.442.93 64.442.93S49.55-.019 43.376 6.156c-9.398 9.398-17.31 20.574-23.679 50.295-6.368 29.721 1.634 45.888 8.002 53.563 6.369 7.675 20.576 17.311 35.274 16.82 14.697-.489 21.152-2.709 36.416-19.759 13.861-17.95 6.531-45.723 5.226-49.48zM73.25 6.917c22.333-1.25 17.417 19.667 17.417 19.667L73.25 6.917z" />
  </svg>
);
export default extendIcon(Deha8);
